import { dispatchMessage, EventType, ToastType } from 'shared/feedback/toasts';
import { i18n } from 'shared/i18n';

export const showMessage = (type: string = 'warning', message: string = '') => {
  dispatchMessage(EventType.ADD_MESSAGE, { type: type as ToastType, text: message });
};

export const errorHandler = (e?: unknown) => {
  let message = i18n('request:error');

  const status = (e as { status?: number } | undefined)?.status;
  if (status) {
    switch (status) {
      case 404:
        message = i18n('request:error.404');
        break;
      default:
        break;
    }
  }

  showMessage('error', message);
};
